import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { IReport } from "../../models/report.model";

export const ReportActions = createActionGroup({
    source: 'Report',
    events: {
        loadReportList: emptyProps(),
        loadReportListSuccess: props<{ reports: IReport[] }>(),
        loadReportListFailure: props<{ error: Error }>(),

        setCurrentReport: props<{ report: IReport }>(),
        clearCurrentReport: emptyProps(),

        getReportURL: props<{ dashboardID: string }>(),
        getReportURLSuccess: props<{ url: string }>(),
        getReportURLFailure: props<{ error: Error }>(),
    },
});
